// CombinedWall reutiliza la misma UI y lógica de EmotionWall, pero consumiendo /feed
import EmotionWall from "./EmotionWall";

const CombinedWall = () => {
  return <EmotionWall feedMode />;
};

export default CombinedWall;
